export default __webpack_public_path__ + "static/media/img7.e5ad428e.jpg";